/** One Room vote, presented either as its exact 0..100 score or 0..5 stars. */
export function isMartinaRoomVoteOutput(outputType: string): boolean {
  return outputType === 'room_presentation' || outputType === 'martina_attention';
}

export function martinaStarsToAttentionScore(stars: number): number {
  return Math.max(0, Math.min(5, Math.round(stars))) * 20;
}

export function martinaAttentionScoreToStars(score: number): number {
  const normalized = Math.max(0, Math.min(100, Math.round(score)));
  return normalized === 0 ? 0 : Math.max(1, Math.round(normalized / 20));
}

export function isMartinaRoomPriorityVote(input: { outputType: string; context?: Record<string, unknown> | null }): boolean {
  if (!isMartinaRoomVoteOutput(input.outputType)) return false;
  const context = input.context ?? {};
  return (context.feedbackKind == null || context.feedbackKind === '' || context.feedbackKind === 'attention_score')
    && context.boardLane == null && context.interaction == null;
}

/** The SQL and JS predicate exclude lane/thumbs feedback from the same table. */
export function martinaRoomPriorityVoteSql(alias: string): string {
  return `(${alias}.output_type IN ('room_presentation','martina_attention')
    AND coalesce(${alias}.context->>'feedbackKind','') IN ('','attention_score')
    AND ${alias}.context->>'boardLane' IS NULL AND ${alias}.context->>'interaction' IS NULL)`;
}

export function readMartinaRoomVote(input: { rating: unknown; context?: Record<string, unknown> | null }): { attentionScore: number; rating: number } | null {
  const context = input.context ?? {};
  if (context.feedbackKind === 'attention_score') {
    const value = context.attentionScore;
    if ((typeof value !== 'number' && typeof value !== 'string') || !/^[0-9]{1,3}$/.test(String(value))) return null;
    const attentionScore = Number(value);
    return attentionScore <= 100 ? { attentionScore, rating: martinaAttentionScoreToStars(attentionScore) } : null;
  }
  const rating = Number(input.rating);
  if (input.rating == null || !Number.isInteger(rating) || rating < 0 || rating > 5) return null;
  return { attentionScore: martinaStarsToAttentionScore(rating), rating };
}
